/**
 * Generated from ch2_p04.fla
 */
export function ch2_p04(this: Ich2_p04) {
	const bg = this.bg;
	ch2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const phone = this.phone;
	ch2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_phone.call(this.phone);
	phone.x = 899.5;
	phone.y = 369.5;
	phone.width = 1392.00;
	phone.height = 739.00;
	phone.alpha = 1.00;
	if (phone.onLayout) phone.onLayout();
	const frameRight = this.frameRight;
	ch2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_wcframelFrame.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_bg(this: Ich2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p04_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_phone(this: Ich2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_phone) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p04_phone", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_wcframeRframe(this: Ich2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_wcframelFrame(this: Ich2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_wcframelFrame) {
	if (this.setLayoutTexture) this.setLayoutTexture("lFrame", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich2_p04Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich2_p04Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich2_p04Sprite extends Ich2_p04Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich2_p04Text extends Ich2_p04Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich2_p04Polygon extends Array<number> {
}
interface Ich2_p04 {
	readonly bg: Ich2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_bg;
	readonly phone: Ich2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_phone;
	readonly frameRight: Ich2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_wcframeRframe;
	readonly frameLeft: Ich2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_wcframelFrame;
}
interface Ich2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_bg extends Ich2_p04Sprite {
}
interface Ich2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_phone extends Ich2_p04Sprite {
}
interface Ich2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_wcframeRframe extends Ich2_p04Sprite {
}
interface Ich2_p04_hh_ch2_p0304_phonepsdAssetchp2_p04_wcframelFrame extends Ich2_p04Sprite {
}
